import { EventKeyValues } from '../constants';
export const isEventKeyEnter = (evt) => evt.key === EventKeyValues.ENTER;
export const callOnEnterKeyEvent = (callback) => (evt) => {
    if (isEventKeyEnter(evt)) {
        return callback(evt);
    }
    return evt;
};
